import React from "react";
import {Link} from "react-router-dom";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import APPCONFIG from "constants/Config";
import {Alert, Button} from "reactstrap";
import {Collections} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";
import ObjectOverride from "components/ObjectOverride";
import FFLTextField from "components/Elements/FFLTextField";
import API from "@beardeddevops/react.api";



/**
 *  @property {Dealers_Object} state
 *  @property {object} model
 *  @property {Dealers_Properties} model.properties
 *  @property {Dealers_Is} model.is
 *  @property {Dealers_Has} model.has
 */
export default class DealerObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Dealers._name);

		this.state.modalFFLLookup = false;
		this.handleFFLExpiration= this.handleFFLExpiration.bind(this)
		this.state.billing_address_lines = null;
		this.state.refreshKey = 0;
		this.state.duplicateDealers = [];
		this.state.duplicateLookupError = false;
		this.state.duplicateTotal = 0;
		this.state.duplicateLookupLoading = false;
		this.duplicateLookupVersion = 0;
	}

	/**
	 * @param prevProps
	 * @param {Dealers_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		if (this.duplicateFields.some(field => prevState[field] !== this.state[field]) || prevState.pkey !== this.state.pkey) {
			this.scheduleDuplicateLookup();
		}

		/** @type {Dealers_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name_display ? object.name_display : object.name_company);
		}
	}

	duplicateFields = ['name_company', 'name_trade', 'name_display', 'name_first', 'name_last', 'ffl'];

	componentDidMount() {
		super.componentDidMount();
		this.scheduleDuplicateLookup();
	}

	componentWillUnmount() {
		super.componentWillUnmount();
		clearTimeout(this.duplicateLookupTimer);
		this.duplicateLookupVersion++;
	}

	scheduleDuplicateLookup = () => {
		clearTimeout(this.duplicateLookupTimer);
		const lookupVersion = ++this.duplicateLookupVersion;
		this.setState({duplicateDealers: [], duplicateTotal: 0, duplicateLookupError: false, duplicateLookupLoading: false});
		if (this.state.pkey) return;
		const dealerFields = {};
		this.duplicateFields.forEach(field => {
			dealerFields[field] = (this.state[field] || '').trim();
		});
		if (!Object.values(dealerFields).some(field => field)) return;
		this.duplicateLookupFields = dealerFields;
		this.duplicateLookupTimer = setTimeout(() => this.loadDuplicateDealers(lookupVersion), 400);
	};

	loadDuplicateDealers = async (lookupVersion) => {
		if (this.state.duplicateLookupLoading) return;
		this.setState({duplicateLookupLoading: true, duplicateLookupError: false});
		const dealers = new API.BuildClass(Types.Dealers._name, API.RequestType.READ_ALL);
		dealers.source = 'dealer_duplicate';
		dealers.search = JSON.stringify(this.duplicateLookupFields);
		dealers.limit = 2;
		try {
			const matches = await dealers.submit(null, API.RequestType.READ_ALL, true);
			if (this._ismounted && lookupVersion === this.duplicateLookupVersion) {
				this.setState({
					duplicateDealers: (matches.items || []).slice(0, 2),
					duplicateTotal: matches.total || 0,
					duplicateLookupLoading: false
				});
			}
		} catch (error) {
			if (this._ismounted && lookupVersion === this.duplicateLookupVersion) {
				this.setState({duplicateLookupError: true, duplicateLookupLoading: false});
			}
		}
	};

	useExistingDealer = (dealer) => {
		if (typeof this.props.afterSave === 'function') {
			this.props.afterSave(dealer);
		} else {
			this.props.history.push('/dealers/' + dealer.binary_id + '-' + dealer.pkey);
		}
	};

	/**
	 * @param {Ffls_Object} ffl
	 */
	loadFFL = (ffl) => {
		this.setState({
			ffl: ffl.ffl,
			name_company: ffl.name_license,
			name_trade: ffl.name_business,
			street_1: ffl.street,
			city: ffl.city,
			state: ffl.state,
			zip: ffl.zip.substring(0, 5),
			number_main: ffl.phone,
			ffl_type: parseInt(ffl.oct_4),
			ffl_types: null
		});
	};

	handleFFLExpiration =(e)=>{
		this.state.ffl_expiration=e.date
	}

	handleBillingAddressLines = (addressLines) => {
		if (JSON.stringify(this.state.billing_address_lines) !== JSON.stringify(addressLines)) {
			this.setState({ billing_address_lines: addressLines });
		}
	}

	parseAndFillAddress = async (addressLines) => {
		if (!Array.isArray(addressLines) || addressLines.some(addressLine => typeof addressLine !== 'string')) {
			return;
		}
		const trimmedLines = addressLines.map(addressLine => addressLine.trim()).filter(Boolean);
		if (trimmedLines.length < 3) {
			return;
		}
		const stateZip = trimmedLines[trimmedLines.length - 1].match(/^([A-Z]{2})\s*-\s*(\d{5}(?:-\d{4})?)$/i);
		if (!stateZip) {
			return;
		}

		// Keep punctuation within address lines and wait for the fields before saving.
		await new Promise(resolve => this.setState({
			street_1: trimmedLines[0],
			street_2: trimmedLines.slice(1, -2).join(' '),
			city: trimmedLines[trimmedLines.length - 2],
			state: stateZip[1].toUpperCase(),
			zip: stateZip[2],
			refreshKey: this.state.refreshKey + 1
		}, resolve));
		await this.handleSubmit(null, true);
	};

	async handleSubmit(e, suppressToast = false, suppressProcess = false) {
		if(this.props?.linkTriggered === true && this.props.dealerObject && localStorage.getItem('dealer_email') !== this.state.email) {
			let dealerEmailChanged = new API.BuildClass(Types.Dealers_Missing_Email_Logs._name, 'POST_EMAIL_CHANGED')
			dealerEmailChanged.object.dealer = this.props.dealerObject.pkey;
			dealerEmailChanged.object.dealer_binary_id = this.props.dealerObject.binary_id;
			dealerEmailChanged.object.prev_email = localStorage.getItem('dealer_email');
			dealerEmailChanged.object.new_email = this.state.email;
			dealerEmailChanged.parent = this.props.dealerObject.binary_id + '-' + this.props.dealerObject.pkey;
			await dealerEmailChanged.submit(null, 'POST_EMAIL_CHANGED', true);
		}

		await super.handleSubmit(e, suppressToast, suppressProcess);
	}

	form = () => {
		/** @type {Dealers_Properties} properties */
		let properties = this.model.properties;
		/** @type {Dealers_Object} object */
		let object = this.state;
		let {loading} = this.state;
		return (
			<div>
				{!object.pkey && this.state.duplicateLookupError &&
					<Alert color="warning">Unable to check for duplicate dealers. Search your dealers before adding a new one.</Alert>}
				{!object.pkey && this.state.duplicateDealers.length > 0 &&
					<Alert color="warning" data-id="dealer-duplicate-warning">
						<strong>Possible duplicate dealer.</strong> A name or FFL matches an existing dealer. Use an existing dealer below or continue adding this dealer.
						{this.state.duplicateDealers.map(dealer => (
							<div key={dealer.binary_id + '-' + dealer.pkey}>
								<Button type="button" color="link" onClick={() => this.useExistingDealer(dealer)}>
									Use this dealer: {dealer.name_display || dealer.name_company || dealer.name_trade || [dealer.name_first, dealer.name_last].filter(Boolean).join(' ')}
								</Button>
								<span>{[dealer.name_company, dealer.name_trade, dealer.ffl, dealer.street_1, dealer.city, dealer.state].filter(Boolean).join(' • ')}</span>
							</div>
						))}
						{this.state.duplicateTotal > 2 &&
							<div><Link target="_blank" rel="noopener noreferrer"
								to={'/dealers?duplicate=' + encodeURIComponent(JSON.stringify(this.duplicateLookupFields))}>
								Resolve matching dealer duplicates ({this.state.duplicateTotal})
							</Link></div>}
					</Alert>}
				<fieldset>
					<div className={"row"}>

						<div className={"col-md"}>
							{/*#region Dealer Information*/}
							<h4 className="section-title">Dealer Information</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Licensess Name"}
									property={properties.name_company}
									value={object.name_company}
									error={object.name_company_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Trade Name"}
									property={properties.name_trade}
									value={object.name_trade}
									error={object.name_trade_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Display Name"}
									property={properties.name_display}
									value={object.name_display}
									error={object.name_display_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={'row'}>
								<div className={'col-md-6'}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.name_first}
											value={object.name_first}
											error={object.name_first_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={'col-md-6'}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.name_last}
											value={object.name_last}
											error={object.name_last_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"EIN"}
									property={properties.ein}
									value={object.ein}
									error={object.ein_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#endregion*/}
							{/*#region Address*/}
							<h4 className="section-title" style={{position: 'relative'}}>
								Address
								<Button onClick={() => this.parseAndFillAddress(object.billing_address_lines)}
								        size={'sm'}
								        color="primary"
								        style={{position: 'absolute', right: 0}
								}>
									<i className={"fa fa-check-square"}/>
									<span className="hidden-xs">&nbsp;&nbsp;EZ Check Address Match</span>
								</Button>
							</h4>
							<div className={"row"}>
								<div className={"col-7"}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.street_1}
											value={object.street_1}
											error={object.street_1_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-5"}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.street_2}
											value={object.street_2}
											error={object.street_2_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.city}
									value={object.city}
									error={object.city_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={"row"}>
								<div className={"col-5"}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.county}
											value={object.county}
											error={object.county_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-4"}>
									<div className="form-group" data-id="dealer-state">
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											update={this.handleSelectPropertyUpdate}
											property={properties.state}
											value={object.state}
											error={object.state_error}
											id={'short'}
											model={Types.States._name}
											nullable={false}
											limit={null}
											masonTest={'somethingHere'}
										/>
									</div>
								</div>
								<div className={"col-3"}>
									<div className="form-group">
										<Framework.Elements.ZipCode
											property={properties.zip}
											value={object.zip}
											error={object.zip_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>

							{/*#endregion*/}
						</div>

						<div className={"col-md"}>
							{/*#region Contact Information*/}
							<h4 className="section-title">Contact Information</h4>
							<div className={"row"}>
								<div className={"col-6"}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											property={properties.number_main}
											value={object.number_main}
											error={object.number_main_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-6"}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											property={properties.number_mobile}
											value={object.number_mobile}
											error={object.number_mobile_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.EmailAddress
									property={properties.email}
									value={object.email}
									error={object.email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#endregion*/}
							{/*#region Federal Firearms License*/}
							<h4 className="section-title" style={{position: 'relative'}}>
								Federal Firearms License
								<Button onClick={this.toggle('modalFFLLookup')} size={"sm"} color="primary"
								        style={{position: 'absolute', right: 0}}>
									<i className={"fa fa-search"}/>
									<span className="hidden-xs">&nbsp;&nbsp;FFL Lookup</span>
								</Button>
							</h4>

							<div className="form-group">
								{this.state.loaded && <FFLTextField
									label={'FFL Number'}
									dealer={object}
									property={properties.ffl}
									value={object.ffl}
									error={object.ffl_error}
									ffl_expiration = {this.handleFFLExpiration}
									update={this.handleTextFieldPropertyUpdate}
									billing_address_lines={this.handleBillingAddressLines}
									refreshKey={this.state.refreshKey}
								/>}
							</div>

							<UniversalModalOverride
								locations={this.props.locations}
								states={this.props.states}
								history={this.props.history}
								name={"FFL Lookup"}
								object={Collections.FFLLookup}
								toggle={this.state.modalFFLLookup}
								reportClose={this.reportClose('modalFFLLookup')}
								afterSave={this.loadFFL}
								size={"xl"}
								hasSubmit={false}
								objectProps={{
									currentFFL: object.ffl
								}}
							/>


							<div className="form-group" data-id="dealer-type">
								<Framework.Elements.Select
									label={"FFL Type"}
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									property={properties.ffl_type}
									value={object.ffl_type}
									error={object.ffl_type_error}
									object={object.ffl_types}
									text={'type-name'}
									limit={null}
								/>
							</div>
							<div className="form-group" data-id="dealer-class">
								<Framework.Elements.Select
									label={"FFL Class"}
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									property={properties.ffl_class}
									value={object.ffl_class}
									error={object.ffl_class_error}
									object={object.ffl_classes}
									text={'class-description'}
									limit={null}
									default={{value: 4, label: "None - Not a SOT"}}
								/>
							</div>
							{/*#endregion*/}
							{/*#region License Image Upload*/}
							<h4 className="section-title">License Image Upload</h4>

							<div className={"form-group"}>
								<p>
									Upload a copy of the dealers license for future reference and
									verification.<br/>
									{object.image ?
										<span>Current Image - <b>{object.image}</b><br/><i>Upload a new
											file to
											replace the old one.</i></span>
										: null}
								</p>
								<Framework.Elements.DropZone
									property={properties.image}
									value={object.image}
									error={object.image_error}
									update={this.handleFileChange}
								/>
							</div>
							{object.image && object.pkey && <div>
								<img
									src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/dealers/' + object.binary_id + '-' + object.pkey + '/images?image=' + object.image.split('.')[0]}
									alt={object.image}
									style={{maxWidth: '100%'}}
								/>
							</div>}

							{/*#endregion*/}
						</div>

					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
